// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LinkWrapper_link-wrapper__t4QkM {
  display: block;
}
.LinkWrapper_link-wrapper__t4QkM .LinkWrapper_link__53NVU {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/LinkWrapper/LinkWrapper.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AAAE;EACE,qBAAA;AAEJ","sourcesContent":[".link-wrapper {\n  display: block;\n  .link {\n    text-decoration: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link-wrapper": `LinkWrapper_link-wrapper__t4QkM`,
	"link": `LinkWrapper_link__53NVU`
};
export default ___CSS_LOADER_EXPORT___;
